export const compareBothTypes = (type1, type2, randomType1, randomType2) => {
  if (type1 === randomType1 && !type2 && !randomType2) {
    return '#a4ff91';
  }
  if (type1 === randomType1 && type2 === randomType2) {
    return '#a4ff91';
  }
  if (type1 === randomType2 && type2 === randomType1) {
    return '#a4ff91';
  }
  if (
    type2 === randomType1
    || type1 === randomType1
    || type1 === randomType2
    || type2 === randomType2
  ) {
    return '#ffe49c';
  }
  return '#ffa1b0';
};

export const compareAbilities = (
  ability1,
  ability2,
  ability3,
  randomAbility1,
  randomAbility2,
  randomAbility3,
) => {
  const pokemonAbilities = [ability1, ability2, ability3];
  const randomPokemonAbilities = [randomAbility1, randomAbility2, randomAbility3];

  // Filtrar habilidades nulas
  const filteredPokemonAbilities = pokemonAbilities.filter((ability) => ability !== null);
  const filteredRandomPokemonAbilities = randomPokemonAbilities.filter(
    (ability) => ability !== null,
  );

  // Verificar si los dos pokemon tienen las mismas habilidades
  if (JSON.stringify(filteredPokemonAbilities) === JSON.stringify(filteredRandomPokemonAbilities)) {
    return '#a4ff91'; // Verde
  }

  // Verificar si alguna habilidad del primer pokemon está presente en el segundo pokemon
  for (let i = 0; i < filteredPokemonAbilities.length; i++) {
    if (filteredRandomPokemonAbilities.includes(filteredPokemonAbilities[i])) {
      return '#ffe49c'; // Amarillo
    }
  }

  // Verificar si alguna habilidad del segundo pokemon está presente en el primer pokemon
  for (let i = 0; i < filteredRandomPokemonAbilities.length; i++) {
    if (filteredPokemonAbilities.includes(filteredRandomPokemonAbilities[i])) {
      return '#ffe49c'; // Amarillo
    }
  }

  // Si no se cumple ninguna de las condiciones anteriores, las habilidades son diferentes
  return '#ffa1b0'; // Rojo
};

export const compareWeight = (weight, randomWeight) => {
  const threshold = 5;

  if (weight === randomWeight) {
    return '#a4ff91';
  }
  if (Math.abs(weight - randomWeight) <= threshold) {
    return '#ffe49c';
  }
  return '#ffa1b0';
};

export const compareHeight = (height, randomHeight) => {
  const threshold = 0.3;

  if (height === randomHeight) {
    return '#a4ff91';
  }
  if (Math.abs(height - randomHeight) <= threshold) {
    return '#ffe49c';
  }
  return '#ffa1b0';
};

export const compareTotalStats = (stat, randomStat) => {
  const threshold = 20;

  if (stat === randomStat) {
    return '#a4ff91';
  }
  if (Math.abs(stat - randomStat) <= threshold) {
    return '#ffe49c';
  }
  return '#ffa1b0';
};

export const compareGeneration = (generation, randomGeneration) => {
  if (generation === randomGeneration) {
    return '#a4ff91';
  }
  return '#ffa1b0';
};

export const returnArrow = (value1, value2) => {
  if (value1 > value2) {
    return <span style={{ color: 'black', fontSize: '22px', marginLeft: '7px' }}>⭣</span>;
  }
  if (value1 < value2) {
    return <span style={{ color: 'black', fontSize: '22px', marginLeft: '7px' }}>⭡</span>;
  }
  return '';
};

export const comparePokemonNames = (name, randomName) => {
  if (name === randomName) {
    return '#a4ff91';
  }
  return '#ffa1b0';
};
